import { ref } from 'vue';
import { siteURL } from '@/configs/Constant';
const isShowfooter = ref(true);
const isShowheader = ref(true);
interface MenuItem {
  name: string;
  link: string;
  target?: string;
  hasDropdown?: boolean;
  showDropdown?: boolean;
  dropdownItems?: DropdownItem[];
}

// 类型定义
interface DropdownItem {
  name: string;
  link: string;
  target?: string;
}

const activeMenu = ref('');
let menuList = ref<MenuItem[]>([
  { name: '首页', link: siteURL },
  { name: '中心概况', link: `${siteURL}zxgk/` },
  { name: '课程中心', link: `${siteURL}html/courseIndex.html` },
  { name: '直播中心', link: `${siteURL}html/liveList.html` },
  { name: '知识文库', link: `${siteURL}html/knowledgeLibrary.html` },
  { name: '数据看板', link: `data-dashboard` },
  {
    name: '加入我们',
    link: `${siteURL}jrwm/`,
    hasDropdown: true,
    showDropdown: false,
    dropdownItems: [{ name: '帮助中心', link: `${siteURL}bzzx/` }],
  },
  { name: '证书查询', link: `${siteURL}html/certiFicate.html` },
  // {
  //   name: '技能传艺',
  //   link: `${siteURL}jncy`,
  //   target: '_blank',
  //   hasDropdown: true,
  //   showDropdown: false,
  //   dropdownItems: [{ name: '职业经理人', link: `${siteURL}jncy/manager`, target: '_blank' }],
  // },
]);

const showMobileMenu = ref(false);
const layheader = ref(null)
export const useLayout = () => {
  const setMenuList = (list: MenuItem[]) => {
    menuList.value = list;
  };
  const setActiveMenu = (menu: string) => {
    activeMenu.value = menu;
  };
  return {
    layheader,
    isShowfooter,
    isShowheader,
    menuList,
    activeMenu,
    setMenuList,
    showMobileMenu,
    setActiveMenu
  };
};
